import React, { useEffect } from 'react';
import { Button } from '@mui/material';
import ConversationGateway from '../../../gateway/conversation/ConversationGateway';

const SystemPromptEditor = ({config, systemPrompt, setSystemPrompt}) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const gateway = new ConversationGateway({ config });
    const [temporarySystemPrompt, setTemporarySystemPrompt] = React.useState('');

    const rotatingGradient = {
        '@keyframes rotate': {
            '0%': {
                backgroundPosition: '0% 50%'
            },
            '100%': {
                backgroundPosition: '360% 50%'
            }
        }
    };
    
    const containerStyles = {
        width: '98vw',
        height: '30vh',
        padding: '2px', // Padding creates space for the gradient border
        backgroundSize: '400% 400%', // Background size is 400% to allow for the gradient to rotate
        background: 'linear-gradient(124deg, rgba(9,9,121,1) 0%, rgba(0,80,255,1) 33%, rgba(0,215,37,0.9) 66%, rgba(9,9,121,1) 100%)',
        // background: isFocused
        //     ? 'linear-gradient(124deg, rgba(0,215,37,0.9) 0%, rgba(0,80,255,1) 33%, rgba(9,9,121,1) 100%)' // Attention-grabbing gradient when focused
        //     : 'linear-gradient(124deg, rgba(9,9,121,1) 0%, rgba(0,80,255,1) 33%, rgba(0,215,37,0.9) 100%)', // Original gradient
        //background: 'linear-gradient(124deg, rgba(9,9,121,1) 0%, rgba(0,80,255,1) 33%, rgba(0,215,37,0.9) 100%)', // Gradient from blue to green
        borderRadius: '8px', // Rounds the corners of the border
        boxSizing: 'border-box',
        // transition: 'background 5s ease', // Smooth transition
        animation: isFocused ? 'rotate 10s linear infinite' : 'none',
        '@keyframes rotate': rotatingGradient['@keyframes rotate']
    };
    
    const textAreaStyles = {
        width: "100%",
        height: '100%',
        fontFamily: 'monospace',
        fontSize: '16px',
        padding: '10px',
        border: 'none', 
        outline: 'none',
        resize: 'none',
        borderRadius: '6px', 
        boxSizing: 'border-box',
        backgroundColor: 'rgb(255, 255, 255)',
    };
    
    const handleUpdateSystemPrompt = (event) => {
        if (temporarySystemPrompt === systemPrompt) {
            return;
        }
        setSystemPrompt(temporarySystemPrompt);
        gateway.updateSystemPrompt(temporarySystemPrompt);

        // Display a notification card to indicate prompt successfully updated
        const notificationCard = document.createElement('div');
        notificationCard.textContent = 'System prompt successfully updated!';
        notificationCard.style.position = 'fixed';
        notificationCard.style.bottom = '20px';
        notificationCard.style.right = '20px';
        notificationCard.style.padding = '10px 20px';
        notificationCard.style.backgroundColor = '#4caf50';
        notificationCard.style.color = 'white';
        notificationCard.style.borderRadius = '5px';
        notificationCard.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
        notificationCard.style.zIndex = '1000';
        document.body.appendChild(notificationCard);

        // Remove the notification card after 3 seconds
        setTimeout(() => {
            document.body.removeChild(notificationCard);
        }, 3000);
    };

    const fetchSystemPrompt = async () => {
        const llmSystemPrompt = await gateway.fetchSystemPrompt();

        setTemporarySystemPrompt(llmSystemPrompt.prompt);
        setSystemPrompt(llmSystemPrompt.prompt);
    }

    useEffect(() => {
        if(temporarySystemPrompt !== systemPrompt) {
            setTemporarySystemPrompt(systemPrompt);
        }
    }, [systemPrompt, temporarySystemPrompt]);

    return (
        <div style={containerStyles}>
            <textarea
                value={temporarySystemPrompt}
                style={textAreaStyles}
                autoCorrect="on"
                spellCheck="true"
                placeholder="System prompt text here..." 
                onChange={(event) => setTemporarySystemPrompt(event.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
            <Button
                variant="contained"
                color="primary"
                size="small"
                style={{marginTop: '10px', width: '50%'}}
                onClick={(event) => fetchSystemPrompt()}
                >
                Load `{config.Model.name}` model prompt
            </Button>
            <Button 
                disabled={systemPrompt === temporarySystemPrompt}
                variant="contained"
                color="primary"
                size="small"
                style={{marginTop: '10px', width: '50%'}}
                onClick={(event) => handleUpdateSystemPrompt(event)}
                >
                Update `{config.Model.name}` model prompt
            </Button>
        </div>
    );
};

export default SystemPromptEditor;